import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams  } from 'react-router-dom';
import { descargarVCardEncriptado, newContact, obtenerDatosEncriptado } from '../../../actions/user/user.actions';
import { defaultEnterprise, userData } from '../../../models/enterprise/enterprise.models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faArrowsLeftRight, faBlenderPhone, faClose, faEarthAmerica, faMobileScreen, faPhone, faShare } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Alerta } from '../../../helpers/alerts/alert';
import { obtenerDatosEmpresa } from '../../../actions/empresas/empresas.actions';
const VCardScreen = () => {

	const params: any = useParams();
	const [searchParams] = useSearchParams();
	const [userData, setUserData] = useState<userData>({
		idUsuario: 0,
		idUsuarioElsa: 0,
		nombreCompleto: '',
		primerApellido: '',
		segundoApellido: '',
		puesto: '',
		correo: '',
		direccionOficina: '',
		telefonoOficina: '',
		extension: '',
		telefonoPersonal: '',
		fotoPerfil: '',
		sitiosInteres: [],
		empresas: []
	});
	const [ lada, setLada ] = React.useState<string>("+52");
	const [defaultEnterprise, setDefaultEnterprise] = useState<defaultEnterprise>();
	const [selectValue, setSelectValue] = useState("0");
	const [message, setMessage] = useState("");
	const [isInvalid, setIsInvalid] = useState(false);

	const ref = useRef<HTMLDialogElement>(null);

	const { idUsuarioElsaEncrypt, idUsuarioEncrypt, idEmpresaUsuarioEncrypt} = React.useMemo(()=>({ 
		idUsuarioElsaEncrypt: searchParams.get('idUsuarioElsa') || "",
		idUsuarioEncrypt: searchParams.get('idUsuario') || "",
		idEmpresaUsuarioEncrypt: searchParams.get('idEmpresaUsuario') || "",
	}),[searchParams]);

	const openModal = useCallback(() => {
		ref.current?.showModal();
	}, [ref]);

	const closeModal = useCallback(() => {
		setIsInvalid(false);
		setMessage("");
		setFormValues({
			nombreContacto: '',
			telefonoContacto: '',
			empresaContacto: '',
			correoContacto: '',
			puestoContacto: '',
			medioSeleccionado: ''
		});
		setSelectValue("0");
		ref.current?.close();
	}, [ref]);

	const [formValues, setFormValues] = useState({
		nombreContacto: "",
		telefonoContacto: "",
		empresaContacto: "",
		correoContacto: "",
		puestoContacto: "",
		medioSeleccionado: ""
	})

	const {
		nombreContacto,
		telefonoContacto,
		empresaContacto,
		correoContacto,
		puestoContacto,
		medioSeleccionado
	} = formValues;

	function validarInputs() {
		let isValid: boolean = true;

		if (!nombreContacto.trim()) {
			isValid = false;
		}

		if (!selectValue) {
			isValid = false;
		}

		if (!empresaContacto.trim()) {
			isValid = false;
		}

		if (!puestoContacto.trim()) {
			isValid = false;
		}

		const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

		if (selectValue === "Correo") {
			if (!regex.test(correoContacto)) {
				isValid = false;
				setMessage("El correo electrónico es inválido.")
			}

			if (!correoContacto.trim()) {
				isValid = false;
			}
		} else if (selectValue === "WhatsApp") {
			if (!telefonoContacto.trim()) {
				isValid = false;
			}

			if (telefonoContacto.length < 10) {
				isValid = false;
				setMessage("El número de teléfono debe tener 10 dígitos.")
			}
		}

		return {
			isValid
		};
	}

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
		const { name, value } = e.target;

		setFormValues(prevState => {
			if (name === 'telefonoContacto' && value.length > 10) {
				return prevState;
			}

			return {
				...prevState,
				[name]: value
			};
		});
	};

	async function guardarContacto() {
		const { isValid } = validarInputs();

		if (isValid) {
			closeModal()

			const response = await newContact({
				idContacto: 0,
				idUsuarioEncriptado: idUsuarioEncrypt,
				nombreContacto: nombreContacto,
				telefonoContacto: lada + telefonoContacto,
				empresaContacto: empresaContacto,
				correoContacto: correoContacto,
				puestoContacto: puestoContacto,
				medioSeleccionado: medioSeleccionado,
				idEmpresaEncriptado: idEmpresaUsuarioEncrypt
			}, true);

			if (response.success) {
				Alerta(response.message, response.success)
				closeModal();
			} else {
				Alerta(response.message, response.success)
				closeModal()
			}

		} else {
			setIsInvalid(true);
			if (message !== "") {
				setMessage("Hay uno o más campos inválidos");
			}
		}
	}

	async function descargarVCardAsync() {
		const response = await descargarVCardEncriptado(decodeURIComponent(idUsuarioElsaEncrypt), decodeURIComponent(idUsuarioEncrypt), decodeURIComponent(idEmpresaUsuarioEncrypt));

		const link = document.createElement('a');
        link.href = `data:text/vcard;base64,${response.data.bytes}`;
        link.download = `${response.data.nombre}.vcf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Alerta("vCard descargada exitosamente", true); // Mostrar éxit
	}

	async function obtenerDatosAsync() {
		const response = await obtenerDatosEncriptado(idUsuarioEncrypt, idEmpresaUsuarioEncrypt);
		if (response.success) {
			let defaultEnterprise: userData = response.data;
			setUserData(defaultEnterprise);
			if(defaultEnterprise?.empresas?.length)
				setDefaultEnterprise(defaultEnterprise.empresas[0])
		}
	}

	useEffect(() => {
		obtenerDatosAsync()
	}, [])

	return (
		<div className="h-full overflow-y-hidden flex justify-center pt-10 pb-10 pl-4 pr-4"
			style={{
				backgroundImage: `url(https://cdn.gdar.com.mx/archivos/${defaultEnterprise?.imagenPortadaEmpresa})`,
				backgroundSize: 'cover'
			}}>
			<div className='flex flex-col justify-center lg:pt-12 sm:pt-10 lg:w-[50%] w-[100%]'>
				<div className='flex flex-col justify-center align-middle items-center'>
					{/* imagen */}
					<div className="avatar">
						<div className="w-52 sm:w-32 md:w-40 lg:w-52 rounded-full">
							<img
								src={`https://cdn.gdar.com.mx/archivos/${userData?.fotoPerfil}`}
								alt="Perfil"
								className="rounded-full"
							/>
						</div>
					</div>

					{/* Nombre y cargo */}
					<div className='flex flex-col justify-center items-center pt-6 w-[80%]'>
						<p className='flex flex-row justify-center lg:text-2xl text-xl pb-4 w-full gap-1' style={{ color: defaultEnterprise?.colorTexto }}>
							<strong className='font-extrabold'>{userData?.nombreCompleto}</strong>{userData?.primerApellido} {userData?.segundoApellido}
						</p>
						<div className="bg-blue-500 h-[1px] w-full" style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}></div>
						<p className='text lg:text-xl text-lg pt-2' style={{ color: defaultEnterprise?.colorTexto }}>
							{userData?.puesto}
						</p>
					</div>
				</div>
				<div className='flex flex-col pt-5 justify-center align-middle items-center'>
					{/* Correo */}
					<div className='flex flex-row justify-between align-middle items-center w-[90%]'>
						<div className='w-[10%]'>
							<FontAwesomeIcon icon={faEnvelope} color={defaultEnterprise?.colorTexto} />
						</div>
						<div className='flex flex-row justify-start w-[80%]'>
							<p className='text-base' style={{ color: defaultEnterprise?.colorTexto }}>{userData?.correo}</p>
						</div>
						<div className='flex flex-row justify-end align-middle items-end gap-5 w-[10%]'>
							<a href={`mailto:${userData?.correo}`} className='flex p-1 justify-center items-center align-middle rounded-full h-8 w-8' style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}>
								<FontAwesomeIcon icon={faEnvelope} color={defaultEnterprise?.colorTexto} />
							</a>
						</div>
					</div>
					<div className="bg-blue-500 justify-center h-[0.5px]  w-[100%] mt-4 mb-4" style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}></div>
					{/* Direccion */}
					<div className='flex flex-row justify-between align-middle items-center w-[90%]'>
						<div className='w-[10%]'>
							<FontAwesomeIcon icon={faBuilding} color={defaultEnterprise?.colorTexto} />
						</div>
						<div className='flex flex-row justify-start w-[80%]'>
							<p className='text-base' style={{ color: defaultEnterprise?.colorTexto }}>{(userData?.direccionOficina || "")}</p>
						</div>
						<div className='flex flex-row justify-end align-middle items-end gap-5 w-[10%]'>
							<a href={`https://www.google.com.mx/maps/search/${(userData?.direccionOficina || "").replace(" ", "+")}`} className='flex p-1 justify-center items-center align-middle rounded-full h-8 w-8' style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}>
								<FontAwesomeIcon icon={faBuilding} color={defaultEnterprise?.colorTexto} />
							</a>
						</div>
					</div>
					<div className="bg-blue-500 justify-center h-[0.5px]  w-[100%] mt-4 mb-4" style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}></div>
					{/* Telefono empresa */}
					<div className='flex flex-row justify-between align-middle items-center w-[90%]'>
						<div className='w-[10%]'>
							<FontAwesomeIcon icon={faBlenderPhone} color={defaultEnterprise?.colorTexto} />
						</div>
						<div className='flex flex-row justify-start align-middle items-center gap-5 w-[80%]'>
							{
								typeof userData?.telefonoOficina === "string" ?
								<p className='text-base' style={{ color: defaultEnterprise?.colorTexto }}>
									+52 {userData?.telefonoOficina.slice(0, 3)} {userData?.telefonoOficina.slice(3, 6)} {userData?.telefonoOficina.slice(6, 10)}
								</p> :
								null
							}
							
							{
								userData?.extension !== "" && (
									<p className='flex flex-row justify-center align-middle items-center' style={{ color: defaultEnterprise?.colorTexto }}>
										Ext. {userData?.extension}
									</p>
								)
							}
						</div>
						<div className='flex flex-row justify-end align-middle items-center gap-5 w-[10%]'>
							<a href={`tel:+52${userData?.telefonoOficina}`} className='flex p-1 justify-center items-center align-middle rounded-full h-8 w-8' style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}>
								<FontAwesomeIcon icon={faBlenderPhone} color={defaultEnterprise?.colorTexto} />
							</a>
						</div>
					</div>
					<div className="bg-blue-500 justify-center h-[0.5px]  w-[100%] mt-4 mb-4" style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}></div>
					{
						userData?.telefonoPersonal !== '' && (
							<>
								<div className='flex flex-row justify-between align-middle items-center w-[90%]'>
									<div className='w-[10%]'>
										<FontAwesomeIcon icon={faMobileScreen} color={defaultEnterprise?.colorTexto} />
									</div>
									<p className='text-base w-[80%]' style={{ color: defaultEnterprise?.colorTexto }}>
										+52 {userData?.telefonoPersonal.slice(0, 3)} {userData?.telefonoPersonal.slice(3, 6)} {userData?.telefonoPersonal.slice(6, 10)}
									</p>
									<div className='flex flex-row justify-center align-middle items-center gap-5'>
										<a href={`https://wa.me/52${userData?.telefonoPersonal}`} className='flex p-1 justify-center items-center align-middle rounded-full h-8 w-8' style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}>
											<FontAwesomeIcon icon={faWhatsapp} color={defaultEnterprise?.colorTexto} />
										</a>
										<a href={`+52${userData?.telefonoPersonal}`} className='flex p-1 justify-center items-center align-middle rounded-full h-8 w-8' style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}>
											<FontAwesomeIcon icon={faPhone} color={defaultEnterprise?.colorTexto} />
										</a>
									</div>
								</div>
								<div className="bg-blue-500 justify-center h-[0.5px]  w-[100%] mt-4 mb-4" style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}></div>
							</>
						)
					}
					{/* Sitios de interés */}
					{/*
						userData?.sitiosInteres.map((sitio, index) => (
							index === 0 && (
								<div key={index} className='flex flex-row justify-start align-middle items-center w-[90%]'>
									<div className='flex flex-col justify-start align-middle items-start w-[10%]'>
										<FontAwesomeIcon icon={faEarthAmerica} color={defaultEnterprise?.colorTexto} />
									</div>
									<a href={sitio.url} className='flex flex-col underline underline-offset-2 justify-start align-middle items-start w-[90%]' style={{ color: defaultEnterprise?.colorTexto }}>
										{sitio.titulo}
									</a>
								</div>
							)
						))
					*/
					}
					{ /* userData?.sitiosInteres?.length ? <div className="bg-blue-500 justify-center h-[0.5px]  w-[100%] mt-4 mb-4" style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}></div> : null */}
				</div>
				{/* Botones */}
				<div className='flex flex-col justify-center align-middle items-center gap-5 pt-10'>
					<div onClick={() => openModal()} className='flex border-0 btn w-[100%] justify-center align-middle items-center' style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}>
						<FontAwesomeIcon icon={faArrowsLeftRight} color={defaultEnterprise?.colorTexto} />
						<p style={{ color: defaultEnterprise?.colorTexto }}>Intercambiar contacto</p>
					</div>
					<div onClick={() => descargarVCardAsync()} className='flex border-0 btn w-[100%] justify-center align-middle items-center' style={{ backgroundColor: defaultEnterprise?.colorPrincipal }}>
						<FontAwesomeIcon icon={faShare} color={defaultEnterprise?.colorTexto} />
						<p style={{ color: defaultEnterprise?.colorTexto }}>Descargar contacto</p>
					</div>
				</div>
				{/* Portales en linea */}
				{
					( userData?.sitiosInteres?.length && userData?.sitiosInteres.length > 0 ) && (
						<div className='flex flex-col justify-center align-middle items-center gap-5 pt-14'>
							<p className='text-lg' style={{ color: defaultEnterprise?.colorTexto }}>Sitios de interés:</p>
							{
								userData?.sitiosInteres.map((sitio, index) => (
									<a tabIndex={index} href={sitio.url} key={index} target='_blank' className='flex btn border-0 w-[100%] justify-center align-middle items-center' style={{ backgroundColor: defaultEnterprise?.colorSecundario }}>
										<p style={{ color: defaultEnterprise?.colorTexto }}>{sitio.titulo}</p>
									</a>
								))
							}
						</div>
					)
				}
				{/* Modal */}
				<dialog ref={ref} className='modal-box text-center bg-white'>
					<div className='flex flex-col'>
						<div className='flex flex-row justify-center pt-2'>
							<h1 className="text-lg font-bold text-black">Compartir contacto</h1>
							<div className="p-2 absolute right-2 top-1" onClick={closeModal}>
								<FontAwesomeIcon icon={faClose} size={'xl'} color='black' />
							</div>
						</div>
						<div className='pt-5 flex flex-col gap-5 justify-center'>
							<input
								type="text"
								placeholder="Nombre(s) y apellido(s)*"
								className="input input-bordered w-full"
								name='nombreContacto'
								id='nombreContacto'
								required={true}
								onChange={handleInputChange}
								value={nombreContacto}
								style={{
									color: '#000000',
									backgroundColor: '#e2e6ff'
								}}
							/>
							<input
								type="text"
								placeholder="Empresa*"
								name='empresaContacto'
								id='empresaContacto'
								required={true}
								onChange={handleInputChange}
								value={empresaContacto}
								className="input input-bordered w-full"
								style={{
									color: '#000000',
									backgroundColor: '#e2e6ff'
								}}
							/>
							<input
								type="text"
								placeholder="Puesto/Cargo*"
								className="input input-bordered w-full"
								required={true}
								name='puestoContacto'
								id='puestoContacto'
								value={puestoContacto}
								onChange={handleInputChange}
								style={{
									color: '#000000',
									backgroundColor: '#e2e6ff'
								}}
							/>
							<input
								type='email'
								placeholder={'Correo*'}
								id='correoContacto'
								className="input input-bordered w-full"
								required={true}
								name={'correoContacto'}
								onChange={handleInputChange}
								value={correoContacto}
								style={{
									color: '#000000',
									backgroundColor: '#e2e6ff'
								}}
							/>
							<div style={{ display:"flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
								
								<input
									type={'phone'}
									placeholder={'Lada*'}
									className="input input-bordered w-full"
									maxLength={3}
									required={true}
									id='lada'
									name={'lada'}
									onChange={(e)=>{ setLada(e.target.value) }}
									value={lada}
									style={{
										maxWidth: 60,
										color: '#000000',
										backgroundColor: '#e2e6ff'
									}}
								/>
								<input
									type={'number'}
									placeholder={'Numero de teléfono*'}
									className="input input-bordered w-full"
									maxLength={10}
									required={true}
									id='telefonoContacto'
									name={'telefonoContacto'}
									onChange={handleInputChange}
									value={telefonoContacto}
									style={{
										color: '#000000',
										flex: 1,
										backgroundColor: '#e2e6ff'
									}}
								/>
							</div>
							
							<div>
								<p>¿Por qué medio te gustaría recibir mi tarjeta de contacto?</p>
							</div>
							<select
								className="select w-full input input-bordered"
								onChange={(e) => {
									console.log(e.target.value);
									setSelectValue(e.target.value);
									handleInputChange(e)
								}}
								id='medioSeleccionado'
								name={'medioSeleccionado'}
								value={selectValue}
								style={{
									color: '#000000',
									backgroundColor: '#e2e6ff'
								}}
							>
								<option value={0}>Selecciona una opción</option>
								{
									defaultEnterprise?.medios?.length && defaultEnterprise?.medios.length > 0 &&
									defaultEnterprise?.medios.map((medio, index) => (
										<option key={index} value={medio}>{medio}</option>
									))
								}
							</select>
						</div>
						{
							isInvalid && (
								<div className='flex flex-col justify-center align-middle items-center pt-5'>
									<p className=' text-red-500 font-semibold'>
										Uno o más campos son invalidos
									</p>
								</div>
							)
						}
						<div className='pt-5'>
							<div onClick={() => guardarContacto()} className='flex border-0 btn w-[100%] justify-center align-middle items-center' style={{ backgroundColor: '#0D6EFD' }}>
								<p style={{ color: 'white' }}>Guardar</p>
							</div>
						</div>
					</div>

				</dialog>
				{/* Logo empresa */}
				{
					defaultEnterprise?.logoEmpresa !== '' && (
						<div className='flex flex-row justify-center align-middle items-center pt-10 pb-10'>
							<img
								src={`https://cdn.gdar.com.mx/archivos/${defaultEnterprise?.logoEmpresa}`}
								alt="Perfil"
								className="w-[120px] h-[60px]"
							/>
						</div>
					)
				}
			</div>
		</div>
	);
};

export default VCardScreen;
